// react-app-polyfill must be the first line
import 'react-app-polyfill/ie11';
import React from 'react';
import { render } from 'react-dom';
import '../style/style.css';
import LoginApp from './LoginApp';

render(<LoginApp />, document.getElementById('loginDiv'));
